"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonRetriableError = void 0;
/**
 * An error that, when thrown, indicates to Inngest that the function should
 * cease all execution and not retry.
 *
 * A `message` must be provided, and an optional `cause` can be provided to
 * provide more context to the error.
 *
 * @public
 */
class NonRetriableError extends Error {
    constructor(message, options) {
        super(message);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.cause = options === null || options === void 0 ? void 0 : options.cause;
        this.name = "NonRetriableError";
    }
}
exports.NonRetriableError = NonRetriableError;
//# sourceMappingURL=NonRetriableError.js.map